module.exports = __webpack_public_path__ + "static/1-small-13cbf3ccf9fb3ed194cd5a8909e33f49.jpg";